import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { ForgotPasswordConfig } from './forgot-password.config';
import { ForgotPasswordComponent } from './forgot-password.component';
import { PageModule } from './page';
import { ResetModule } from './reset';

export const ForgotPasswordModule = angular
  .module('app.forgot-password', [uiRouter, PageModule.name, ResetModule.name])
  .config(ForgotPasswordConfig)
  .component('updForgotPassword', ForgotPasswordComponent);
